// NOTE: RUN-2927 — les spots sont rattachés à une catégorie de premier niveau.
// Toute sous-catégorie doit donc être résolue vers son parent avant de filtrer
// les spots ; une catégorie déjà racine se résout en elle-même (c'est ce cas
// qui produisait un `undefined.id` dans New.vue#selectPlace).
export const findTopCategoryId = (categories, categoryId) => {
  const id = Number(categoryId)
  if (!Number.isFinite(id) || id <= 0) return null
  const parent = (categories || []).find((category) =>
    (category.childs || []).some((child) => Number(child.id) === id)
  )
  return parent ? Number(parent.id) : id
}

// NOTE: cherche d'abord dans les sous-catégories (cas nominal d'un checkpoint)
// puis dans les racines — contrairement au getter company/findCategoryById qui
// ne parcourt que les `childs` et renvoie null pour une catégorie racine.
export const findCategoryById = (categories, categoryId) => {
  const id = Number(categoryId)
  if (!Number.isFinite(id) || id <= 0) return null
  const list = categories || []
  for (const category of list) {
    const child = (category.childs || []).find((c) => Number(c.id) === id)
    if (child) return child
  }
  return list.find((category) => Number(category.id) === id) || null
}
